import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/core/analytics/analytics.service';
import { EventOriginEnum, NavigateToEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { AppManager } from '@services/managers/app.manager';

@Component({
    templateUrl: './organization-classes-header.component.html',
    standalone: false
})
export class OrganizationClassesHeaderComponent {

  private readonly analyticsService = inject(AnalyticsService);
  private readonly appManager = inject(AppManager);
  private readonly router = inject(Router);

  /**
   * Navigate to the import view.
   * @return A promise that emits true when the navigation succeeded.
   */
  public async importOrganizationClass(): Promise<boolean> {
    this.analyticsService.trackNavigationEvent(
      EventOriginEnum.BREADCRUMB,
      NavigateToEnum.IMPORT_DIALOG,
      EntityTypeEnum.ORGANIZATION_CLASS,
    );
    return await this.router.navigate([
      'organization',
      this.appManager.currentOrganization.id,
      'configuration',
      'organization-classes',
      'import'
    ]);
  }
}
